<template lang="">
  <div>
    <div class="">
      <!-- 公共位置 -->
      <PositionGuid :posGuids="posGuids"></PositionGuid>
      <!-- 公共位置结束 -->
      <div class="lists gWidth  padding bg-white">
        <div>
          <div class="left_tit flex align-center flex-center  text-weight">
            栏目导航
          </div>
          <div class="news_l padding-bottom leftss">
            <ul class="big_ul">
              <li
                class="default"
                v-for="(item, indexLlm) in leftlists"
                :key="item.id"
              >
                <div v-if="item.child">
                  <div
                    class="flex align-center zhudong_f cursor"
                    @click="shows(item, indexLlm)"
                    :class="[isZhuanti ? 'left_fathersel' : 'left_father']"
                  >
                    <span class=" text-weight">{{ item.name }}</span>
                  </div>
                  <ul class="zhudong_l" v-if="!item.isShow">
                    <li
                      class="cursor"
                      @click="liebiao3(itemt.id, indext, itemt.id)"
                      v-for="(itemt, indext) in item.child"
                      :key="itemt.id"
                      :class="[
                        currentindex == indext
                          ? 'left_fatherselin'
                          : 'left_fatherin',
                      ]"
                    >
                      <span class="text-sm">{{ itemt.name }}</span>
                    </li>
                  </ul>
                </div>
                <div v-else>
                  <ul class="">
                    <li
                      class="cursor flex align-center"
                      @click="down(item.id, item.id)"
                      :class="[!isZhuanti ? 'left_fathersel' : 'left_father']"
                    >
                      <span class=" text-weight">{{ item.name }}</span>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="news_r padding-bottom">
          <span class="right_tit">专题专栏</span>
            <div class="news_data_kuan" v-if="id == 153 || id== 154 || id== 155 || id== 156 || id== 157">
              <span style="width:80px" class="news_data_kuan_xz"  @click="liebiao3(153, 12 ,0)" v-if="id == 153">  全部
              <!-- <a href="/#/ztzl?id=154&index=12" style="color:#fff"></a> -->
            </span>
            <span style="width:80px"  @click="liebiao3(153, 12 ,0)" v-else>  全部
              <!-- <a href="/#/ztzl?id=154&index=12" style="color:#fff"></a> -->
            </span>


             <span style="width:80px"  class="news_data_kuan_xz"  @click="liebiao3(154, 12 ,0)"  v-if="id == 154">   中央
              <!-- <a href="/#/ztzl?id=154&index=12" style="color:#fff"></a> -->
            </span>
            <span style="width:80px"  @click="liebiao3(154, 12 ,0)"  v-else>   中央
              <!-- <a href="/#/ztzl?id=154&index=12" style="color:#fff"></a> -->
            </span>


             <span style="width:60px" class="news_data_kuan_xz"  @click="liebiao3(155, 12 ,0)" v-if="id == 155">省
              <!-- <a href="/#/ztzl?id=155&index=12" style="color:#fff"></a> -->
            </span>
            <span style="width:60px" @click="liebiao3(155, 12 ,0)"  v-else>省
              <!-- <a href="/#/ztzl?id=155&index=12" style="color:#fff"></a> -->
            </span>

             <span style="width:60px" class="news_data_kuan_xz"   @click="liebiao3(156, 12 ,0)" v-if="id == 156">市
              <!-- <a href="/#/ztzl?id=156&index=12" style="color:#fff"></a> -->
            </span>
            <span style="width:60px" @click="liebiao3(156, 12 ,0)"  v-else>市
              <!-- <a href="/#/ztzl?id=156&index=12" style="color:#fff"></a> -->
            </span>


             <span style="width:60px" class="news_data_kuan_xz"  @click="liebiao3(157, 12 ,0)" v-if="id == 157">区
              <!-- <a href="/#/ztzl?id=157&index=12" style="color:#fff"></a> -->
            </span>
            <span style="width:60px" @click="liebiao3(157, 12 ,0)"  v-else>区
              <!-- <a href="/#/ztzl?id=157&index=12" style="color:#fff"></a> -->
            </span>
          
          
          </div>
          <div class="news_r_b" style="padding-bottom: 0;" v-if="!isDown">
          
            <ul>
              <li
                class="flex flex-between "
                v-for="item in liebiaos"
                :key="item.id"
              >
                <router-link
                  :to="`/Dxarticles/${item.id}`"
                  class="news_info"
                  style="width: 60%;"
                  >{{ item.title }}</router-link
                >
                <span class="news_data">{{ item.created_at }}</span>
              </li>
            </ul>
          </div>
          <!-- #region -->
          <div class="news_r_b" style="padding-top: 15px;" v-else>
            <ul>
              <li
                v-for="(item, indexd) in downs"
                :key="indexd"
                class="down"
                style="margin-bottom: 0;"
              >
                <span class="down_tit">{{ item.title }}</span>
                <div class="down_des text-sm margin-top">
                  {{ item.description }}
                </div>
                <div
                  class="flex down_content align-center margin-top-sm padding-bootom flex-between"
                >
                  <p
                    class="font-xs margin-right "
                    v-for="(item2, index2) in item.fj"
                    :key="index2"
                  >
                    <span class="text-blue down_link ">下载地址：</span>
                    <a :href="item2.fujian" class="cursor">{{
                      item2.fjname
                    }}</a>
                  </p>
                  <p class="flex align-center ">
                    <img
                      src="@/assets/gengxinshijian.png"
                      style="height: 14px;width: 14px;margin-right: 3px;"
                    />
                    <span class="text-blue font-xs"
                      >更新时间：{{ item.created_at }}</span
                    >
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div>
            <div
              class="page"
              v-if="
                (!isDown && liebiaos.length > 0) || (isDown && downs.length > 0)
              "
            >
              <a href="#" @click="go(-1)" class="big_prev">上一页</a>
              <a href="#" @click="go(-1)" class="small_prev">&lt;</a>
              <a
                href="#"
                v-for="(item, index) in pages"
                :key="index"
                @click="select(item)"
                :class="{ active: item == currentPage }"
                >{{ item }}</a
              >
              <a href="#" @click="go(1)" class="big_prev">下一页</a>
              <a href="#" @click="go(1)" class="small_prev">&gt;</a>
            </div>
            <div class="text-center" v-else>
              暂无数据
            </div>
          </div>
          <!-- #endregion -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { leftlist, liebiao, downlist } from "@/api/gxq";
import PositionGuid from "../../components/PositionGuid/PositionGuid";
export default {
  name: "Ztzl",
  components: {
    PositionGuid,
  },
  data() {
    return {
      articleTitle: '保定国家高新技术产业开发区', // 初始标题
      contentSource: '保定国家高新技术产业开发区', // 初始内容来源
      posGuids: [
        {
          title: "专题专栏",
          link: "",
        },
      ],
      currentindex: "",
      lLm: [],
      zcjdList: [],
      currentPage: 1,
      totlePage: 45,
      leftlists: [],
      liebiaos: [],
      id: 25,
      downs: [],
      isDown: false,
      down_id: "",
      isZhuanti: true, //判断是专题专栏还是文件下载，默认是专题专栏
      leftoneId: "", //左侧第一个下拉中的第一个id
      isLoading: false,
    };
  },
  mounted() {
    // console.log(this.$route.query);
    this.leftlist2();
    this.clearExistingMetaTags('ArticleTitle');
      this.clearExistingMetaTags('ContentSource');
  },
  beforeRouteEnter(to, from, next) {
    // console.log('测试打印111-----')
    // ...
    // console.log(to.query.id);
    // next();
    next((vm) => {
      if (to.query.id && to.query.index) {
        vm.id = to.query.id;
        vm.liebiao2(to.query.id, to.query.index, 0);
      }
    });
  },
  methods: {
    // 清除具有指定名称的现有 meta 标签
    clearExistingMetaTags(name) {
        const existingTags = document.querySelectorAll(`meta[name="${name}"]`);
        existingTags.forEach(tag => tag.parentNode.removeChild(tag));
    },

    async leftlist2() {
      var data3 = await leftlist({
        id: 24,
      });
      this.leftlists = data3.data[0].child;
      this.leftoneId = data3.data[0].child[0].child[0].id;
      if (!this.$route.query.id) {
        this.liebiao2(this.leftoneId, 0, 0);
      }
    },
    liebiao3(id, indext, currentPage) {
      this.id = id;
      this.liebiao2(id, indext, currentPage);
    },
    async liebiao2(id, indext, currentPage) {
      console.log("点击了页码");
      console.log(id);

      if (currentPage) {
        // console.log('点击左侧获取这里传的currentPage实参没有任何意义，只是说明是通过点击左侧获取到的列表，这时候把当前页重置为1')
        this.currentPage = 1;
      }
      // console.log(indext)
      this.currentindex = indext;
      this.isDown = false;
      const { data } = await liebiao({
        id: id ? id : this.id,
        page: this.currentPage - 1,
      });
      this.liebiaos = data.data;
      this.totlePage = data.pages;
    },
    async down(id, currentPage) {
      this.leftlists.forEach((every) => {
        every.isShow = true;
      });
      this.isZhuanti = false;
      if (currentPage) {
        this.currentPage = 1;
      }
      this.down_id = id;
      this.isDown = true;
      const { data } = await downlist({
        id: this.down_id,
        page: this.currentPage - 1,
      });
      this.downs = data.data;
      this.totlePage = data.pages;
    },
    shows() {
      this.liebiao2(this.leftoneId, 0, 0);
      this.isZhuanti = true;
      this.leftlists.forEach((every) => {
        every["isShow"] = false;
      });
    },
    // 分页
    select(n) {
      // console.log(typeof(n))
      if (typeof n === "string") {
        return;
      }
      if (typeof n === this.currentPage) {
        return;
      }
      this.currentPage = n;
      if (this.isDown) {
        this.down(this.down_id);
      } else {
        this.liebiao2(this.id, this.currentindex);
      }
    },
    go(k) {
      this.currentPage += k;
      this.currentPage < 1
        ? (this.currentPage = 1)
        : this.currentPage > this.totlePage
        ? (this.currentPage = this.totlePage)
        : null;
      if (this.isDown) {
        this.down(this.down_id);
      } else {
        this.liebiao2(this.id, this.currentindex);
      }
    },
  },
  computed: {
    pages() {
      const t = this.totlePage;
      const c = this.currentPage;
      if (t <= 10) {
        return t;
      } else {
        if (c <= 5) {
          return [1, 2, 3, 4, 5, 6, 7, 8, 9, "...", t];
        }
        if (c >= t - 4) {
          return [
            1,
            "...",
            t - 8,
            t - 7,
            t - 6,
            t - 5,
            t - 4,
            t - 3,
            t - 2,
            t - 1,
            t,
          ];
        } else {
          return [
            1,
            "...",
            c - 3,
            c - 2,
            c - 1,
            c,
            c + 1,
            c + 2,
            c + 3,
            "...",
            t,
          ];
        }
      }
    },
  },
};
</script>
<style src="../../../vab/styles/gaikuang/gaikuang_big.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_mid.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_small.css" scoped></style>
<style scoped>
.nav li:nth-child(5) {
  background-color: rgba(0, 140, 255, 1);
}
.mores_span span:nth-child(5) {
  display: block;
}

.news_data_kuan {
  display: flex;

flex-direction: row;
flex-wrap: nowrap;
justify-content: space-around;
align-items: stretch;
}

.news_data_kuan span{

            background-image: linear-gradient(to right, #1FA2FF 0%, #12D8FA  51%, #1FA2FF  100%);
            margin: 10px;
            padding: 15px;
            width: 50px;
            text-align: center;
            text-transform: uppercase;
            transition: 0.5s;
            background-size: 200% auto;
            color: white;            
            box-shadow: 0 0 20px #eee;
            border-radius: 10px;
            display: block;
}
.news_data_kuan_xz {
             background-image: linear-gradient(to right, #016bd5 0%, #2b04a1  51%, #1a0af4 100%) !important;
            color: #fff;
            text-decoration: none;
          }

.down_tit {
  color: #666666;
}
.down_des {
  color: #999;
}
.font-xs {
  font-size: 12px;
}
.down {
  border-bottom: 1px dashed #ccc;
  padding: 10px;
}
</style>
